import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../../servicios/spinner.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-spinner',
  template: (environment.club!='cenit')?`
  <div class="overlay" *ngIf="isLoading$ | async">
    <div class="lds-dual-ring"></div>
  </div>`:`<div class="overlay" *ngIf="isLoading$ | async">
  <div class="lds-dual-ring-cenit"></div>
</div>`,
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  isLoading$ = this.Spnr.isLoading$;
  constructor(private Spnr:SpinnerService) { }

  ngOnInit() {}

}
